var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMotorOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#ff4d4d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-motor-off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_36",
    "data-name": 36
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.1,57.09v4.6H126.84V84.88h36.57a.41.41,0,0,1,.41.41v29.88h16.72V100H186v40.43h-5.43V125.62h-16.3v12.73a.87.87,0,0,1-.24.59l-22.33,22a2.89,2.89,0,0,1-2,.84H98.93a2.92,2.92,0,0,1-2.16-1L84,146.62l-2-2.2H72a4.07,4.07,0,0,1-4.07-4.07V125.62H48.71v18.59H43.27v-42h5.44v18.59H67.93v-14.1A4.07,4.07,0,0,1,72,102.64h9.6l2-2.27L96.4,85.86a2.93,2.93,0,0,1,2.18-1H121.2V61.69H105.53v-4.6H142.1m2.82-6.69H102.71a3.86,3.86,0,0,0-3.86,3.87V64.51a3.86,3.86,0,0,0,3.86,3.86h11.81v9.82H98.58a9.57,9.57,0,0,0-7.19,3.25L78.58,96H72a10.76,10.76,0,0,0-10.76,10.76v7.42H55.39v-15a3.55,3.55,0,0,0-3.55-3.55H40.14a3.55,3.55,0,0,0-3.55,3.55v48.27a3.55,3.55,0,0,0,3.55,3.55h11.7a3.55,3.55,0,0,0,3.55-3.55v-15h5.85v8A10.76,10.76,0,0,0,72,151.11h7l12.81,14.17a9.59,9.59,0,0,0,7.12,3.17h40.7a9.59,9.59,0,0,0,6.73-2.76l22.33-22a7.52,7.52,0,0,0,2.24-5.35v-6h2.92v11a3.82,3.82,0,0,0,3.82,3.82h11.17a3.82,3.82,0,0,0,3.82-3.82V97.15a3.81,3.81,0,0,0-3.82-3.81H177.67a3.81,3.81,0,0,0-3.82,3.81v11.33h-3.34V85.29a7.1,7.1,0,0,0-7.1-7.1H133.53V68.37h11.39a3.86,3.86,0,0,0,3.86-3.86V54.27a3.86,3.86,0,0,0-3.86-3.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "134.78 121.23 109.5 155.49 118.47 127.92 102.82 127.92 118.47 96.99 134.78 96.99 119.32 121.23 134.78 121.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMotorOff);
export default __webpack_public_path__ + "static/media/ic-motor-off.3ecb8fa096227a7a068d91672666fd0e.svg";
export { ForwardRef as ReactComponent };